export const VENDOR_LIST = "SPEED_VENDOR_LIST";
export const GAME_LIST = "SPEED_GAME_LIST";
export const SPEED_GAME_ACCESS = "SPEED_GAME_ACCESS";